import React from 'react';
import { connect } from 'react-redux';
import { divisionActions } from '../_actions';
import { NewDivisionModal, DeleteDivisionModal } from "../Divisions"
import { Form, Row, Col } from 'reactstrap';
import 'react-bootstrap-table-next/dist/react-bootstrap-table2.min.css';
import BootstrapTable from 'react-bootstrap-table-next';
import cellEditFactory, { Type } from 'react-bootstrap-table2-editor';

function deleteLinkFormatter(value, row, index, field) {
  return (
    <DeleteDivisionModal className="full-width" color="danger" project_id={row.value}></DeleteDivisionModal>
  );
}

function selectDataFormatterLabel(cell, row) {
  return <span>{row.label}</span>
}

const columns = [{
  dataField: 'label',
  text: 'Division',
  editable: true
},{
  dataField: 'delete',
  text: 'Supprimer',
  editable: false,
  formatter: deleteLinkFormatter
}];

const remote={
  filter: false,
  pagination: false,
  sort: false,
  cellEdit: true
}

class AllDivisions extends React.Component {

  constructor(props) {
      super(props);
      this.state = {
        divisions: []
      };
    }

  componentDidMount() {
    this.props.getAllDivisions();
  }

  onTableChange(type, newState) {
    if(type==="cellEdit")
    {
      this.props.handleChange(newState.cellEdit);
    }
    return true;
  }

  render() {
    return (
      <div style={{marginLeft:"5%", marginRight:"5%"}}>
        <Row>
          <Col md="3" xs="6" style={{marginBottom: "10px"}}><NewDivisionModal buttonLabel="Nouvelle division" /></Col><Col md="1" xs="6"></Col>
        </Row>
        <br/>
        { this.props.divisions && this.props.divisions.items && this.props.divisions.items.length > 0 &&
          <div className="table-responsive-sm">
            <BootstrapTable style={{ margin:"auto"}} bootstrap4={true} bordered={false} keyField='value' remote={remote} cellEdit={ cellEditFactory({ mode: 'click', blurToSave: true }) } onTableChange={this.onTableChange.bind(this)} data={ this.props.divisions.items } columns={ columns } />
          </div>
        }
      </div>
    )

  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    handleChange: (edit) => {
      dispatch(divisionActions.update(edit));
    },
    getAllDivisions: () => {
      dispatch(divisionActions.getAll());
    }
  }
}

function mapStateToProps(state){
    return {
        divisions: state.divisions
    }
}

const connectedAllDivisions = connect(mapStateToProps, mapDispatchToProps)(AllDivisions);
export { connectedAllDivisions as AllDivisions };
